<template>
  <div v-if="!model.$disabled">
    <w-label
      :label-for="sid"
      :title="title"
      :show-label="showLabel"
      :model="model"
      :description="description"
      :next-number="nextNumber"
      :bold-label="boldLabel"
    >
      <template v-slot:description>
        <slot name="description" />
      </template>
    </w-label>

    <label
      :for="sid"
      class="select"
      v-bind:class="{'state-error': model.$error, 'state-disabled':disabled}"
    >
      <select
        v-if="renderReady"
        ref="input"
        :value="svalue"
        :disabled="disabled"
        @input="onInput($event)"
        @change="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        :placeholder="placeholder"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :name="model.$form.testPath ? model.$path : undefined"
      >
        <option v-if="placeholder" disabled="disabled" value :selected="svalue">{{placeholder}}</option>
        <template v-for="(value, index) in values">
          <option
            v-if="!value.children"
            :key="index"
            :value="value.value"
            :disabled="value.disabled"
            :selected="svalue == value.value"
          >{{value.text}}</option>
          <optgroup v-else :key="index" :label="value.text">
            <option
              v-for="(child, index2) in value.children"
              :value="child.value"
              :disabled="child.disabled"
              :key="index2"
              :selected="svalue == value.value"
            >{{child.text}}</option>
          </optgroup>
        </template>
      </select>
      <i></i>
    </label>
    <w-error :model="model" @focus="$refs.input.focus()"></w-error>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: tooltipVisibility}"

import titleMixin from '../mixins/titleMixin';
import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-select',
  components: {WError, WTooltip},
  mixins: [modelMixin],
  props: {
    values: Array,
    label: {
      type: [String, Boolean],
      default: true
    },
    placeholder: String,
    setTitleAsPlaceholder: {
      type: Boolean,
      default: false
    },
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      // default: () => ({
      //   level: null,
      //   value: null,
      //   type: null
      // }),
      required: false
    }
  },
  data() {
    return {
      sid: 'ddw' + Math.round(Math.random() * 1000000)
    };
  },
  methods: {
    textValue() {
      const ff = this.svalue;
      for (let i = 0; i < this.values.length; i++) {
        const vv = this.values[i];
        if (vv.children) {
          for (let j = 0; j < vv.children.length; j++) {
            if (vv.children[j].value === ff) {
              return vv.children[j].text;
            }
          }
        } else {
          if (vv.value === ff) {
            return vv.text;
          }
        }
      }
      return this.placeholder || '';
    }
  },
  mounted() {
    if (this.setTitleAsPlaceholder) {
      this.placeholder = this.getTitle;
      this.label = false;
    }
  }
};
</script>


